import React from "react";
import {
  Box,
  Skeleton,
  Card,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";

const LoadingDevice = () => (
  <>
    {/* Header with title and search */}
    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, p: 1 }}>
      <Box>
        <Skeleton variant="text" width={180} height={32} />
        <Skeleton variant="text" width={100} height={24} />
      </Box>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Skeleton
          variant="rectangular"
          width={200}
          height={40}
          sx={{ borderRadius: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={40}
          height={40}
          sx={{ borderRadius: 1 }}
        />
        <Skeleton
          variant="rectangular"
          width={40}
          height={40}
          sx={{ borderRadius: 1 }}
        />
      </Box>
    </Box>

    {/* Map area */}
    <Box sx={{ position: "relative", mb: 3 }}>
      <Skeleton
        variant="rectangular"
        height={500}
        sx={{
          borderRadius: 1,
          backgroundColor: "rgba(0, 0, 0, 0.11)",
        }}
      />

      {/* Map controls */}
      <Box sx={{ position: "absolute", top: 10, left: 10 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            width={32}
            height={32}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Box>
    </Box>

    {/* Device cards */}
    <Grid container spacing={2}>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
        <Grid size={{ xs: 12, sm: 6 }} key={item}>
          <Card variant="outlined" sx={{ borderRadius: 2 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Skeleton variant="circular" width={36} height={36} />
                  <Skeleton variant="text" width={100} height={24} />
                </Box>
                <Skeleton variant="text" width={60} height={30} />
              </Box>
              <Skeleton variant="text" width="60%" height={20} />

              <Box
                sx={{
                  mt: 2,
                  pt: 2,
                  borderTop: "1px solid rgba(0, 0, 0, 0.08)",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="caption">
                      <Skeleton width={80} />
                    </Typography>
                    <Skeleton variant="text" width={40} height={24} />
                  </Box>
                  <Box>
                    <Typography variant="caption">
                      <Skeleton width={60} />
                    </Typography>
                    <Skeleton variant="text" width={40} height={24} />
                  </Box>
                  <Box>
                    <Typography variant="caption">
                      <Skeleton width={40} />
                    </Typography>
                    <Skeleton variant="text" width={60} height={24} />
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </>
);

export default LoadingDevice;
